import {Component, Input} from '@angular/core';
import {PopupField, PopupLinkField} from "_@api/map-service/popup.service";

@Component({
  selector: 'app-dialog-component',
  imports: [],
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.scss'
})
export class DialogComponent {
  @Input({ required: true }) fields: PopupField[] = [];
  @Input() context: any = {};
  
  handleLinkClick(event: MouseEvent, f: PopupLinkField) {
    event.preventDefault();
    event.stopPropagation();
    
    if (f.onClick) {
      return f.onClick(event, f);
    }
    
    if (f.href) {
      window.open(f.href, '_blank', 'noopener');
    }
  }
}
